import React from "react"
import { ReactComponent as EyeIcon } from "@ciq/shared/assets/icons/map/eye_icon.svg"
import { ReactComponent as EyeShutIcon } from "@ciq/shared/assets/icons/map/eye_shut_icon.svg"
import { useFilterQueryParams } from "../../hooks/filter_query_params"

/**
 * Toggle button for showing/hiding building utilization metrics on the map.
 * Displays an eye icon when metrics are visible and a shut eye icon when hidden.
 */
export function OccupancyToggle() {
  const { isHidingOccupancy, toggleOccupancy } = useFilterQueryParams()

  const title = isHidingOccupancy
    ? "Show building utilization metrics"
    : "Hide building utilization metrics"

  return (
    <button
      type="button"
      className="occupancy-toggle-button"
      onClick={toggleOccupancy}
      title={title}
      aria-label={title}
      aria-pressed={!isHidingOccupancy}
    >
      {isHidingOccupancy ? <EyeShutIcon /> : <EyeIcon />}
    </button>
  )
}
